var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-box"},[_c('div',{staticClass:"body-left"},[_c(_setup.TheHomeLeftTop),_c(_setup.TheHomeLeftBottom)],1),_c('div',{staticClass:"body-right"},[_c(_setup.TheHomeRight)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }